export default function Delete(props) {
  return (
    <svg 
      width={31} 
      height={21}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
        <g transform="translate(1.000000, 1.000000)" stroke="#171B24">
          <path d="M21.644787,1.25713666 L28.7642731,8.81428417 C29.1271139,9.19943021 29.1271139,9.80056979 28.7642731,10.1857158 L21.644787,17.7428633 C20.8889572,18.5451569 19.835559,19 18.7333096,19 L2.41027664,19 C1.30570714,19 0.41027664,18.1045695 0.41027664,17 L0.41027664,2 C0.41027664,0.8954305 1.30570714,2.02906125e-16 2.41027664,0 L18.7333096,0 C19.835559,7.76514185e-16 20.8889572,0.45484312 21.644787,1.25713666 Z" strokeWidth="2" transform="translate(14.705138, 9.500000) scale(-1, 1) translate(-14.705138, -9.500000) " />
          <g strokeWidth="1" fillRule="evenodd" transform="translate(17.000000, 7.000000)">
            <path d="M0,-5.68434189e-14 L4.95555571,4.95555571" strokeWidth="2" />
            <path d="M0,-5.68434189e-14 L4.95555571,4.95555571" strokeWidth="2" transform="translate(2.477778, 2.477778) scale(-1, 1) translate(-2.477778, -2.477778) " />
          </g>
        </g>
      </g>
    </svg>
  )
}
